import { State as RouteState } from 'config/routes';

export function* accessibilityPageHandler(params: RouteState) {
  return;
}
